import { 
    setSupplyPower, 
    setSupplyVoltage, 
    setAvailableKVA, 
    setController, 
    setOxygen, 
    setNitrogen, 
    setH2S, 
    setCO2, 
    setCorrosion, 
    setParaffin, 
    setScale, 
    setSandSolids, 
    setViscosityEmulsion, 
    setPacker, 
    setChemical, 
    setYTool, 
    setScdaCompatibility, 
    setPressureSensor, 
    setNotes, 
    setSupplyPowerList,
    setControllerList
  } from "../../../store/jetlift/jetlift-input/OthersSlice";
import { useAppDispatch } from "../../../store/hooks/StoreHooks";

const useJetliftOthersFacade = () => {
    const dispatch = useAppDispatch();

    const updateSupplyPower = (payload: string) => {
        return dispatch(setSupplyPower(payload));
    };
    const updateSupplyVoltage = (payload: string) => {
        return dispatch(setSupplyVoltage(payload));
    };
    const updateAvailableKVA = (payload: string) => {
        return dispatch(setAvailableKVA(payload));
    };
    const updateController = (payload: string) => {
        return dispatch(setController(payload));
    };

    const updateOxygen = (payload: string) => {
        return dispatch(setOxygen(payload));
    };
    const updateNitrogen = (payload: string) => {
        return dispatch(setNitrogen(payload));
    };
    const updateH2S = (payload: string) => {
        return dispatch(setH2S(payload));
    };
    const updateCO2 = (payload: string) => {
        return dispatch(setCO2(payload));
    };

    const updateCorrosion = (payload: string) => {
        return dispatch(setCorrosion(payload));
    };
    const updateParaffin = (payload: string) => {
        return dispatch(setParaffin(payload));
    };
    const updateScale = (payload: string) => {
        return dispatch(setScale(payload));
    };
    const updateSandSolids = (payload: string) => {
        return dispatch(setSandSolids(payload));
    };
    const updateSupplyPowerList = (payload: any) => {
        return dispatch(setSupplyPowerList(payload));
    };
    const updateControllerList = (payload: any) => {
        return dispatch(setControllerList(payload));
    };
    const updateViscosityEmulsion = (payload: string) => {
        return dispatch(setViscosityEmulsion(payload));
    };

    const updatePacker = (payload: string) => {
        return dispatch(setPacker(payload));
    };
    const updateChemical = (payload: string) => {
        return dispatch(setChemical(payload));
    };
    const updateYTool = (payload: string) => {
        return dispatch(setYTool(payload));
    };
    const updateScdaCompatibility = (payload: string) => {
        return dispatch(setScdaCompatibility(payload));
    };
    const updatePressureSensor = (payload: string) => {
        return dispatch(setPressureSensor(payload));
    };

    const updateNotes = (payload: string) => {
        return dispatch(setNotes(payload));
    };

    return {
        updateSupplyPowerList,
        updateControllerList,
        updateSupplyPower,
        updateSupplyVoltage,
        updateAvailableKVA,
        updateController,
        updateOxygen,
        updateNitrogen,
        updateH2S,
        updateCO2,
        updateCorrosion,
        updateParaffin,
        updateScale,
        updateSandSolids,
        updateViscosityEmulsion,
        updatePacker,
        updateChemical,
        updateYTool,
        updateScdaCompatibility,
        updatePressureSensor,
        updateNotes
    };
};

export default useJetliftOthersFacade;

